import { render } from "./BaseTable.vue?vue&type=template&id=8288ffcc&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=8288ffcc&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8288ffcc"]])

export default __exports__